// ReleaseNote9.jsx
import { Box, Typography } from "@mui/material";

const ReleaseNote9 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 9.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        Introducing trademark image retrieval capability within Bibliographic
        Data Extraction.
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>

        <ul style={{ margin: 0, paddingLeft: "5%" }}>
          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>
                US Trademark Image Download{" "}
                <span style={{ color: "green", fontSize: "0.85em", verticalAlign: "super" }}>
                  New!
                </span>
              </strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              The US Trademark Image Download module is now available under
              Bibliographic Data Extraction. This feature allows users to:
            </Typography>
            <ul style={{ margin: "8px 0 0 0", paddingLeft: "5%" }}>
              <li style={{ marginBottom: "8px" }}>
                <Typography variant="body2">Download US trademark images in bulk.</Typography>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Typography variant="body2">
                  Submit one or more US trademark application numbers in a single request.
                </Typography>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Typography variant="body2">Download images in PNG or JPG format.</Typography>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Typography variant="body2">Process up to 500 trademark images per request.</Typography>
              </li>
            </ul>
            <Typography variant="body2" sx={{ mt: 1 }}>
              The feature provides a faster and more efficient way to retrieve
              trademark image assets for review, reporting, and downstream
              processing activities.
            </Typography>
          </li>
        </ul>

        <Typography variant="body2" sx={{ mt: 1}}>
          Refer to the FAQ and Tutorial sections for more details on this feature.
        </Typography>
      </Box>
    </Box>
  );
};

export default ReleaseNote9;
